import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';

import { Alert } from 'bs';


class FlashNotification extends Component {
    static propTypes = {
        notification: PropTypes.object,
        notificationId: PropTypes.string.isRequired,
        removeNotification: PropTypes.func,
        closeCallback: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            notification: {},
            notificationId: '',
        };
    }

    render() {
        const notification = this.props.notification;
        const message = notification.message;
        const flavor = notification.flavor;
        const timeout = notification.timeout;
        const notificationId = this.props.notificationId;
        const removeNotification = this.props.removeNotification;
        const closeCallback = notification.closeCallback;
        let _closeCallback = null;

        if (!timeout) {
            _closeCallback = () => {
                if (isFunction(closeCallback)) {
                    closeCallback();
                }
                removeNotification(notificationId);
            };
        } else {
            setTimeout(function() {
                removeNotification(notificationId);
            }, timeout);
        }

        if (isFunction(closeCallback)) {
            _closeCallback = () => {
                closeCallback();
                removeNotification(notificationId);
            };
        }

        return (
            <Alert flavor={flavor} closeCallback={_closeCallback}>
                {message}
            </Alert>
        );
    }
}

export default FlashNotification;
